import { FC, Suspense, useState } from 'react';
import ReportHubCard from './ReportHubCard';
import { reportData, ReportSubtype, ReportType } from '../../models/Report';
import ReportHubModal, { AllDropdowns } from './ReportHubModals/GenerateReport/ReportHubModal';
import { ThreeDotLoader } from '../Fallback/ThreeDotsLoader';
import { Class } from '../../models/Class';
import { useAppSelector } from '../../redux/hooks';
import { selectUser } from '../../redux/reducers/userSlice';
import { CustomBranding, mapCustomBranding } from '../../models/User';

interface Props {
  allDropdowns: AllDropdowns;
  setAllDropdowns: (allDropdowns: AllDropdowns) => void;
  reportType: ReportType;
  allClassesData: Class[];
}

const ReportHubList: FC<Props> = ({ reportType, allDropdowns, setAllDropdowns, allClassesData }) => {
  const userRedux = useAppSelector(selectUser);
  const miamiBrand =
    userRedux?.network?.customBranding &&
    mapCustomBranding[userRedux?.network?.customBranding] === CustomBranding.MIAMI;
  const [visibleGenerateDialog, setVisibleGenerateDialog] = useState<boolean>(false);
  const [selectedReportSubtype, setSelectedReportSubtype] = useState<ReportSubtype | null>(null);
  return (
    <>
      <h1 className="font-semibold md:text-2xl text-lg m-2">
        {reportType === ReportType.DIAGNOSTIC ? 'Diagnostic' : 'Progress'} Reports
      </h1>
      {reportType === ReportType.DIAGNOSTIC ? (
        <div className="flex md:flex-row flex-column justify-content-center">
          <ReportHubCard
            cardHeader={reportData.DiagnosticSummary.header}
            cardSummary={reportData.DiagnosticSummary.summary}
            reportSubtype={ReportSubtype.DIAGNOSTIC_SUMMARY}
            setVisibleGenerateDialog={setVisibleGenerateDialog}
            setSelectedReportSubtype={setSelectedReportSubtype}
          />
          <ReportHubCard
            cardHeader={reportData.DiagnosticStudentUnfinishedDiagnostic.header}
            cardSummary={reportData.DiagnosticStudentUnfinishedDiagnostic.summary}
            reportSubtype={ReportSubtype.DIAGNOSTIC_STUDENTS_UNFINISHED_DIAGNOSTIC}
            setVisibleGenerateDialog={setVisibleGenerateDialog}
            setSelectedReportSubtype={setSelectedReportSubtype}
          />
        </div>
      ) : (
        <>
          <div className="flex md:flex-row flex-column justify-content-center">
            <ReportHubCard
              cardHeader={reportData.ProgressDetailedSkillReport.header}
              cardSummary={reportData.ProgressDetailedSkillReport.summary}
              reportSubtype={ReportSubtype.PROGRESS_DETAILED_SKILL_REPORT}
              setVisibleGenerateDialog={setVisibleGenerateDialog}
              setSelectedReportSubtype={setSelectedReportSubtype}
            />
            <ReportHubCard
              cardHeader={
                miamiBrand
                  ? reportData.ProgressSkillChallengeHistory.header
                  : reportData.ProgressSkillSAssessmentHistory.header
              }
              cardSummary={
                miamiBrand
                  ? reportData.ProgressSkillChallengeHistory.summary
                  : reportData.ProgressSkillSAssessmentHistory.summary
              }
              reportSubtype={ReportSubtype.PROGRESS_SKILL_ASSESSMENT_HISTORY}
              setVisibleGenerateDialog={setVisibleGenerateDialog}
              setSelectedReportSubtype={setSelectedReportSubtype}
            />
          </div>
        </>
      )}
      {visibleGenerateDialog && (
        <Suspense fallback={<ThreeDotLoader />}>
          <ReportHubModal
            visible={visibleGenerateDialog}
            setVisible={setVisibleGenerateDialog}
            selectedReportSubtype={selectedReportSubtype}
            allClassesData={allClassesData}
            allDropdowns={allDropdowns}
            setAllDropdowns={setAllDropdowns}
            miamiBrand={miamiBrand as boolean}
          />
        </Suspense>
      )}
    </>
  );
};

export default ReportHubList;
